import { Controller } from 'react-hook-form';

import { Box, FormControl, FormControlLabel, FormHelperText, Switch } from '@mui/material';

export interface BasicSwitchInputProps {
  label: string;
  helperText?: string;
  control: any;
  inputName: string;
  disabled?: boolean;
  errorsInputName?: string;
  onChange?: any;
}

export default function BasicSwitchInput(props: BasicSwitchInputProps) {
  const { control, label, inputName, helperText, disabled = false, onChange } = props;

  return (
    <Controller
      control={control}
      name={inputName}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error}>
          <FormControlLabel
            {...field}
            control={
              <Switch
                color="primary"
                disabled={disabled}
                onChange={(e) => {
                  field.onChange(e);
                  onChange && onChange(e);
                }}
                checked={field.value}
              />
            }
            label={<Box sx={{ fontSize: '2rem' }}>{label}</Box>}
          />
          {(!!fieldState.error || helperText) && (
            <FormHelperText>{fieldState.error?.message || helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
